import { withLiveSiteStyle } from "./useLiveSiteStyle.js";
import { withNativeStyle } from "./useNativeStyle.js";
import { withWixStyle } from "./useWixStyle.js";
const themeStrategy = ({ useWixStyles, useNativeStyles, ...rest } = {}, isBmPlatform = false) => {
  return useNativeStyles ? withNativeStyle(rest) : useWixStyles ?? isBmPlatform ? withWixStyle(rest) : withLiveSiteStyle(rest);
};
export {
  themeStrategy
};
//# sourceMappingURL=themeStrategy.js.map
